module.exports = __webpack_public_path__ + "img/s3-1.b366065c.jpg";